import { render, staticRenderFns } from "./events-organization-filters.vue?vue&type=template&id=3e8aa6c8&scoped=true&"
import script from "./events-organization-filters.vue?vue&type=script&lang=js&"
export * from "./events-organization-filters.vue?vue&type=script&lang=js&"
import style0 from "./events-organization-filters.vue?vue&type=style&index=0&id=3e8aa6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8aa6c8",
  null
  
)

export default component.exports